export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"orange",
    text_primary:"#ffebbb",
    text_secondary:"#f5c7f7",
    card:"#171721",
    card_light: '#191924',
    button:"orange",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#be1adb",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}